import { render, staticRenderFns } from "./report-claim.vue?vue&type=template&id=fd70faf0&scoped=true"
import script from "./report-claim.vue?vue&type=script&lang=js"
export * from "./report-claim.vue?vue&type=script&lang=js"
import style0 from "./report-claim.vue?vue&type=style&index=0&id=fd70faf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd70faf0",
  null
  
)

export default component.exports